import * as i18n from 'google-libphonenumber';

angular.module('filters')
    .filter('formatPhoneNumber', () => (input, regionCode) => {

        let phoneUtil;
        let number;

        if (input) {

            phoneUtil = i18n.PhoneNumberUtil.getInstance();
            number = phoneUtil.parseAndKeepRawInput(input);

            if (!regionCode) {

                regionCode = phoneUtil.getRegionCodeForNumber(number);

            }

            return phoneUtil.formatOutOfCountryCallingNumber(number, regionCode);

        }

        return input;

    });



// WEBPACK FOOTER //
// ./scripts/filters/formatPhoneNumber.js